import styled from 'styled-components'

import colors from 'styles/colors'

interface RadioButtonProps {
    active: any
    clickFn?: any
}

export const RadioButton = ({ active, clickFn }: RadioButtonProps) => {
    return (
        <Button
            onClick={(e: React.MouseEvent<HTMLElement>) => {
                if (clickFn) {
                    e.stopPropagation()
                    clickFn()
                }
            }}
        >
            <Inner $active={active} />
        </Button>
    )
}


interface InnerProps {
    $active: boolean
}

const Button = styled.div`
    position: relative;
    width: 2rem;
    height: 2rem;
    border: 0.151rem solid rgba(185, 193, 210, 0.8);
    border-radius: 50%;
    flex-shrink: 0;
`;

const Inner = styled.div<InnerProps>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(${({ $active }) => ($active ? 1 : 0)});
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
    background: ${colors.blueLighter};
    transition: transform 0.2s;
`;